import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { PillarsSection } from './components/PillarsSection';
import { MentorshipSection } from './components/MentorshipSection';
import { ProductsSection } from './components/ProductsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { MentoriaPage } from './pages/MentoriaPage';
import { ProductosPage } from './pages/ProductosPage';
function HomePage() {
  return <div className="min-h-screen bg-neutral-950 text-white selection:bg-red-500/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <PillarsSection data-id="element-5" />
        <MentorshipSection data-id="element-6" />
        <ProductsSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM has rendered before scrolling
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' as ScrollBehavior
      });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [pathname]);
  return null;
}
export function App() {
  useEffect(() => {
    document.title = 'Protocolo Sniper';
  }, []);
  return <HashRouter data-id="element-11">
      <ScrollToTop data-id="element-12" />
      <Routes data-id="element-13">
        <Route path="/" element={<HomePage data-id="element-15" />} data-id="element-14" />
        <Route path="/index" element={<HomePage data-id="element-17" />} data-id="element-16" />
        <Route path="/mentoria" element={<MentoriaPage data-id="element-19" />} data-id="element-18" />
        <Route path="/productos" element={<ProductosPage data-id="element-21" />} data-id="element-20" />
      </Routes>
    </HashRouter>;
}